module.exports = __webpack_public_path__ + "img/RISE-alt.dc0f8e20.svg";